// notifications.js
// Firestore utility for sending notifications (invites, messages, alerts, etc.)

import { db } from "../services/firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

/**
 * Send a notification to a user.
 * @param {Object} notification - { recipientId, senderId, type, title, message, date, time, status, buyerId, sellerId, listingId, lastActionBy }
 * @returns {Promise<string>} notificationId
 */
export async function sendNotification({ recipientId, senderId, type = "general", title, message, date, time, location = null, status = "unread", buyerId = null, sellerId = null, listingId = null, lastActionBy = null }) {
  const notificationData = {
    recipientId,
    senderId,
    type,
    title,
    message,
    date,
    time,
    location,
    status,
    createdAt: serverTimestamp(),
  };
  
  // Include buyerId, sellerId, and listingId if provided (preserve roles across notifications)
  if (buyerId) notificationData.buyerId = buyerId;
  if (sellerId) notificationData.sellerId = sellerId;
  if (listingId) notificationData.listingId = listingId;
  if (lastActionBy) notificationData.lastActionBy = lastActionBy;
  
  const ref = await addDoc(collection(db, "notifications"), notificationData);
  return ref.id;
}

/**
 * Send a meeting invite notification to a user (invite-specific).
 * @param {Object} invite - { recipientId, senderId, date, time, message, location, buyerId, sellerId, listingId }
 * @returns {Promise<string>} notificationId
 */
export async function sendInviteNotification({ recipientId, senderId, date, time, message, location, buyerId = null, sellerId = null, listingId = null }) {
  return sendNotification({
    recipientId,
    senderId,
    type: "invite",
    title: "Meeting Invite",
    message,
    date,
    time,
    location,
    status: "pending",
    buyerId,
    sellerId,
    listingId,
    lastActionBy: senderId  // Sender is the last to act, so they see "Awaiting Response"
  });
}
